import { AxiosResponse } from "axios";
import { getRequest } from "../commonActions/get";
import { Requests } from "../../config/api";

export const GetTransactionData = async ()  => {
    console.log('query')
    try {
     
      const response: AxiosResponse = await getRequest({
        route: Requests.get.getTransaction,
      });
      
  
     console.log('respon', response)
      const transactions = response?.data?.transactions;
      const status = response?.status;
      const success = response?.data?.success
      const message = response?.data?.message;
      const errors = response?.data?.message;
      const totalData = response?.data?.totalData
  
      return {
        status: status,
        transactions,
        errors,
        message: message,
        success,
        totalData,
      };
    } catch (error) {
    
      throw error;
    }
  };
